import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../lib/api";
import InquiryForm from "../components/InquiryForm";
import SEO from "../lib/SEO";

export default function CakeDetail() {
    const { slug } = useParams();
    const [cake, setCake] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        setNotFound(false);
        setCake(null);
        api.get(`/cakes/${slug}`)
            .then((r) => setCake(r.data))
            .catch(() => setNotFound(true));
    }, [slug]);

    if (notFound) {
        return (
            <main className="pt-32 pb-20 max-w-3xl mx-auto px-4 text-center" data-testid="cake-notfound">
                <h2 className="font-display text-3xl mb-4">Cake not found</h2>
                <Link to="/shop" className="btn-pink mt-4">Back to shop</Link>
            </main>
        );
    }

    if (!cake) {
        return <main className="pt-32 pb-20 max-w-3xl mx-auto px-4 text-center text-ink-soft" data-testid="cake-loading">Loading…</main>;
    }

    return (
        <main data-testid="cake-detail-page">
            <SEO
                title={`${cake.name} — Cake Central`}
                description={cake.short_description}
                image={cake.image_url}
                path={`/shop/${cake.slug}`}
                jsonLd={{
                    "@context": "https://schema.org",
                    "@type": "Product",
                    name: cake.name,
                    image: cake.image_url,
                    description: cake.short_description,
                    category: cake.category,
                    brand: { "@type": "Brand", name: "Cake Central" },
                }}
            />

            <section className="pt-24 md:pt-[10rem] pb-16 bg-[#FFF7FB]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <Link to="/shop" className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-ink-soft hover:text-blush mb-8 transition-colors" data-testid="back-to-shop">
                        <ArrowLeft size={14} /> Back to shop
                    </Link>

                    <div className="grid md:grid-cols-2 gap-10 md:gap-16">
                        <div>
                            <div className="aspect-[4/5] overflow-hidden">
                                <img src={cake.image_url} alt={cake.name} className="w-full h-full object-cover" />
                            </div>
                        </div>
                        <div>
                            <p className="text-xs tracking-[0.3em] uppercase text-ink-soft mb-3">{cake.category}</p>
                            <h1 className="font-display text-4xl md:text-5xl text-ink mb-5 leading-none" data-testid="cake-title">
                                {cake.name}
                            </h1>
                            <p className="text-ink-soft leading-relaxed mb-8 whitespace-pre-line">{cake.long_description}</p>
                            <div className="h-px bg-[#EAE3DE] mb-8" />
                            <p className="text-xs tracking-[0.3em] uppercase text-ink-soft mb-4">Enquire about this cake</p>
                            <InquiryForm cake={cake} compact />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
